export const suggestionsHelpContent = {
  medicalEvidence: {
    title: "Medical evidence",
    description: "Guidance about medical evidence proof",
    faqs: [
      {
        question: "Where can I find it?",
        answer: `You can request a GP letter from your doctor’s surgery, find appointment or diagnosis letters in your medical correspondence, and get repeat prescription information from your GP, pharmacy, or your online NHS account. <div style="height: 10px;"></div>If you need help and support on where to find your documentation, please <a target="_blank"  href="https://www.unitedutilities.com/providing-documentation/#:~:text=If%20you%20have%20been%20asked,them%20before%20sending%20to%20us.">follow this link</a>`,
      },
    ],
  },
  deceasedOccupier: {
    title: "Deceased occupier",
    description: "Guidance about deceased occupier proof",
    faqs: [
      {
        question: "Where can I find it?",
        answer:
          'You can find these documents in your Council Tax letters, benefit account notifications, or your tenancy agreement from your landlord or housing provider. Some councils also show this in your online council account, if you have one. <div style="height: 10px;"></div>If you need help and support on where to find your documentation, please <a target="_blank"  href="https://www.unitedutilities.com/providing-documentation/#:~:text=If%20you%20have%20been%20asked,them%20before%20sending%20to%20us.">follow this link</a>',
      },
    ],
  },
  changeInWorkingHours: {
    title: "Change in working hours due to no fault of your own",
    description:
      "Guidance about change in working hours due to no fault of your own proof",
    faqs: [
      {
        question: "Where can I find it?",
        answer: `You can get pay slips from your employer and UC application documents from your online Universal Credit account. <div style="height: 10px;"></div>If you need help and support on where to find your documentation, please <a target="_blank"  href="https://www.unitedutilities.com/providing-documentation/#:~:text=If%20you%20have%20been%20asked,them%20before%20sending%20to%20us.">follow this link</a>`,
      },
    ],
  },
  maritalSplit: {
    title: "Marital split",
    description: "Guidance about marital split proof",
    faqs: [
      {
        question: "Where can I find it?",
        answer:
          'You can find these documents in your Council Tax letters, benefit account notifications, or your tenancy agreement from your landlord or housing provider. Some councils also show this in your online council account, if you have one. <div style="height: 10px;"></div>If you need help and support on where to find your documentation, please <a target="_blank"  href="https://www.unitedutilities.com/providing-documentation/#:~:text=If%20you%20have%20been%20asked,them%20before%20sending%20to%20us.">follow this link</a>',
      },
    ],
  },
  redundancy: {
    title: "Redundancy",
    description: "Guidance about redundancy proof",
    faqs: [
      {
        question: "Where can I find it?",
        answer: `Your redundancy letter will be provided by your employer. UC application documents can be found in your online Universal Credit account. <div style="height: 10px;"></div>If you need help and support on where to find your documentation, please <a target="_blank"  href="https://www.unitedutilities.com/providing-documentation/#:~:text=If%20you%20have%20been%20asked,them%20before%20sending%20to%20us.">follow this link</a>`,
      },
    ],
  },
  dropInIncomeDueToIllness: {
    title: "Drop in income due to illness",
    description: "Guidance about drop in income due to illness proof",
    faqs: [
      {
        question: "Where can I find it?",
        answer: `You can get pay slips from your employer, sicknotes from your GP or medical provider, and UC documents from your online Universal Credit account. <div style="height: 10px;"></div>If you need help and support on where to find your documentation, please <a target="_blank"  href="https://www.unitedutilities.com/providing-documentation/#:~:text=If%20you%20have%20been%20asked,them%20before%20sending%20to%20us.">follow this link</a>`,
      },
    ],
  },
};
